import { render, staticRenderFns } from "./partyForm.vue?vue&type=template&id=1b70fd98&scoped=true"
import script from "./partyForm.vue?vue&type=script&lang=js"
export * from "./partyForm.vue?vue&type=script&lang=js"
import style0 from "./partyForm.vue?vue&type=style&index=0&id=1b70fd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70fd98",
  null
  
)

export default component.exports